/* jshint esnext: true */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['card'];

  connect() {
    this.sync();
  }

  select() {
    this.sync();
  }

  sync() {
    const groups = {};
    this.cardTargets.forEach((card) => {
      const input = card.querySelector('input[type=radio]');
      if (!input) return;
      const name = input.name;
      if (!groups[name]) groups[name] = [];
      groups[name].push({ card, input });
    });

    Object.values(groups).forEach((entries) => {
      entries.forEach(({ card, input }) => {
        if (input.checked) {
          card.classList.add('selected');
        } else {
          card.classList.remove('selected');
        }
      });
    });
  }
}
